import { render } from "./OrgNotifications.vue?vue&type=template&id=da69e26e&ts=true"
import script from "./OrgNotifications.vue?vue&type=script&lang=ts"
export * from "./OrgNotifications.vue?vue&type=script&lang=ts"

import "./OrgNotifications.vue?vue&type=style&index=0&id=da69e26e&lang=scss"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__